// Lokal inloggning (ADR 0062): Vites server skapar en token för exempelbyråns
// ägare eller medarbetare. Cognito ersätter den i steg 9.3.
export type LokalRoll = 'agare' | 'medarbetare';

export const LOKALA_ROLLER: { roll: LokalRoll; etikett: string }[] = [
  { roll: 'agare', etikett: 'Logga in som Karin Ek, ägare' },
  { roll: 'medarbetare', etikett: 'Logga in som Johan, medarbetare' },
];

export async function hamtaLokalToken(roll: LokalRoll, f: typeof fetch = fetch): Promise<string> {
  const svar = await f('/__lokal/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roll }),
  });
  const kropp = (await svar.json().catch(() => ({}))) as { token?: string; fel?: string };
  if (!svar.ok || !kropp.token) {
    throw new Error(
      kropp.fel ?? 'Den lokala inloggningen svarar inte. Kör kontot med pnpm dev:admin.',
    );
  }
  return kropp.token;
}
